export enum AuthAudience {
  STAFF = "STAFF",
  MEMBER = "MEMBER",
}
